var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"card-body p-0"},[_c('b-row',[_c('b-col',[_c('router-link',{attrs:{"to":{ name: 'Risk', params: { id: _vm.risk.id }}}},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.risk.name))])]),_c('div',{staticClass:"mb-2"},[_c('markdown',{attrs:{"content":_vm.risk.comments}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }